<template>
   <ul class="menu-nav">
    <li
      v-for="item in MenuList"
      :key="item.id"
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item"
    >
      <router-link
        :to="item.url"
        v-if="item.childs.length == 0"
        class="menu-link"
      >
        <b-icon class="menu-icon" font-scale="1.5" :icon="item.icon"></b-icon>
        <span class="menu-text">{{ item.title }}</span>
      </router-link>

      <a href="#" class="menu-link menu-toggle" v-if="item.childs.length > 0">
        <b-icon class="menu-icon" font-scale="1.5" :icon="item.icon"></b-icon>
        <span class="menu-text">{{ item.title }}</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu" v-if="item.childs.length > 0">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav pl-8">
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">{{ item.title }}</span>
            </span>
          </li>
          <li
            v-for="sitem in item.childs"
            :key="sitem.id"
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
          >
            <router-link :to="sitem.url" class="menu-link">
              <!-- <b-icon :icon="sitem.icon"></b-icon> -->
              <span class="menu-text">{{ sitem.title }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </li>
    <!-- <router-link
      v-for="item in MenuList"
      :key="item.id"
      :to="item.url"
      v-if="item.childs.length == 0"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      
    </router-link> -->
  </ul>
</template>

<script>
//import ApiService from "../../../core/services/api.service";
import httpHelper from "../../../helpers/httpHelper";
export default {
  name: "KTMenu",
  data() {
    return {
      MenuList: [],
    };
  },
  methods: {
    menuChilds(list, parent) {
      var menus = [];
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        if (element.parent == parent) {
          menus.push({
            icon: element.icon,
            parent: element.parent,
            row_order: element.row_order,
            title: element.title,
            url: element.url,
            childs: this.menuChilds(list, element.id),
          });
        }
      }
      return menus.sort((a, b) => (a.row_order > b.row_order ? 1 : -1));
    },
    refreshMenu() {
      httpHelper.setAuth();
      httpHelper.getData("menu").then((res) => {
        console.log(res);
        // this.MenuList = res.result.sort((a, b) =>
        //   a.row_order > b.row_order ? 1 : -1
        // );
        this.MenuList = this.menuChilds(res.result, null);
      });
    },
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
  },
  mounted() {
    var self = this;
    this.$root.$on("refresh_menu", (interesting_data) => {
      this.refreshMenu();
    });
    this.refreshMenu();
  },
};
</script>
